export const ja = {
  lang: 'ja',
  accessibility: {
    info: '案内',
    success: '成功',
    warning: '警告',
    error: 'エラー',
    close: '閉じる',
    page: 'ページ',
    prev: '前',
    next: '次',
    back: '戻る',
  },
  ConfirmModal: {
    title: 'お知らせ',
    confirmText: '確認',
    cancelText: 'キャンセル',
  },
  AlertModal: {
    title: 'お知らせ',
    confirmText: '確認',
  },
  NoticeModal: {
    closeText: '閉じる',
    checkReplayText: '今日一日中この窓を開けず',
  },
  Dropdown: {
    placeholder: '選択',
    filterPlaceholder: '検索フィルタ',
  },
  DropdownFilter: {
    reset: '初期化',
    confirm: '適用',
    all: '全部',
  },
  DatePicker: {
    placeholder: '日付を選択',
    footer: {
      now: '今',
      today: '今日',
      ok: '決定',
      clear: 'クリア',
    },
  },
  DatePickerRange: {
    placeholder: ['開始日付', '終了日付'],
    dataPreset: {
      'today': '今日',
      '1-week': '一週間',
      '1-month': '1ヶ月',
      '3-month': '3ヶ月',
      '6-month': '6ヶ月',
      '1-year': '1年',
      'all': '全体',
    },
  },
  TimePicker: {
    placeholder: '時間を選択',
    footer: {
      ok: '決定',
      clear: 'クリア',
    },
    unit: {
      hour: '時',
      minute: '分',
    },
  },
  TimeRangePicker: {
    placeholder: ['開始時間', '終了時間'],
  },
  FileUpload: {
    label: 'アップロード',
  },
  ImageUpload: {
    label: '画像アップロード',
    fail: '画像の読み込みに失敗しました',
  },
  Table: {
    noDataText: 'データがありません',
  },
  ColumnViewController: {
    noFixedItemsText: '固定情報はありません',
    fixedSectionTitle: '固定情報',
    listSectionTitle: 'リスト情報',
    max: '最大',
    items: '個',
  },
  CategorySelector: {
    levelCategory: '次 カテゴリ',
    selectParentCategoryLine1: '親カテゴリを',
    selectParentCategoryLine2: 'お選びください。',
  },
};
